import Content from './components/Content';
import { FileOperationOverlayProvider } from './hooks';
import { FilesExplorerProps } from './types';

export default function FilesExplorer(props: FilesExplorerProps) {
  return (
    <FileOperationOverlayProvider>
      <Content {...props} />
    </FileOperationOverlayProvider>
  );
}
